<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Returns</h4>
                        <h6 class="card-subtitle"></h6>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table no-wrap v-middle">
                                <thead>
                                <tr class="border-0">
                                    <th class="border-0">Date</th>
                                    <th class="border-0">Item</th>
                                    <th class="border-0">Quantity Transferred</th>
                                    <th class="border-0">Source Warehouse</th>
                                    <th class="border-0">Destination Warehouse</th>
                                    <th class="border-0"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(c, index) in commodities" v-bind:key="index">
                                    <td>{{c.name}}</td>
                                    <td style="width:30%">{{c.description | truncate(50, '...')}}</td>
                                    <td>{{c.code}}</td>
                                    <td>{{c.hs_code || '-'}}</td>
                                    <td>{{c.unit.symbol}}</td>
                                    <td>
                                        <div class="btn-group">
                                            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i class="ti-settings"></i>
                                            </button>
                                            <div class="dropdown-menu" x-placement="bottom-start">
                                                <a class="dropdown-item" href="javascript:void(0)"><i class="ti-truck"></i> Add Supplier</a>
                                                <a class="dropdown-item" href="javascript:void(0)"><i class="ti-pencil-alt"></i> Edit</a>
                                                <a class="dropdown-item" href="javascript:void(0)"><i class="ti-trash"></i> Delete</a>
                                                <a class="dropdown-item" href="javascript:void(0)"><i class="ti-comment-alt"></i> Comments</a>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <paginate
                        :page-count=pageCount
                        :page-range="3"
                        :margin-pages="2"
                        :click-handler="pageHandler"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'"
                        :next-text="'Next'"
                        :next-class="'page-link'"
                        :container-class="'pagination float-right'"
                        :page-class="'page-link'">
                </paginate>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../common/Blockie";
    import Paginate from 'vuejs-paginate';

    export default {
        name: "Growers",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Blockie, Paginate},
        data() {
            return {
                commodities: [],
                pageCount: 1,
                total: 0
            };
        },
        mounted() {
            this.getTransfers(1);
        },
        methods: {
            getTransfers(page) {
                this.$http
                .get("/commodities/", {
                    params: {
                        page: page,
                        perPage: 10
                    }
                })
                .then(reply => {
                    this.total       = reply.data.total;
                    this.commodities = reply.data.commodities;
                    this.setPageCount();
                })
                .catch(err => {
                    console.log(err);
                });
            },
            pageHandler(pageNum) {
                this.getTransfers(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= 10 ? 1 : Math.ceil(this.total / 10);
            }
        }
    }
</script>

<style scoped>

</style>